import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/products/collections'

const ProductCollectionsApiV2 = {

  /**
   * Get all Product Collections
   * @param {string} name - collection name option for filtering
   * @param {Array} ids - array of collection ids option for filtering
   */
  getCollections: async (name, ids) => {
    const path   = API_PATH
    const params = {
      name : name,
      ids  : ids
    }

    const response = axios.get(path, { params })
    return response
  },

  /*
   * Get list of Product Collections
   * Invoke `GET api/v2/admins/products/collections
   * @param {object} tableState - ReactTable final state
   */
  get: async ({ tableState }) => {
    const params = QueryParamsUtil.format(tableState)
    const path   = API_PATH

    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Get list of Product Collection Items
   * Invoke `GET api/v2/admins/products/collections/:id/items
   * @param {object} tableState - ReactTable final state
   * @param {string} id - id of product collection
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  show: async ({ id, tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/${id}/items`

    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Create Product Collections
   * Invoke `POST api/v2/admins/products/collections
   * @param {object} values - endpoint's params, key: name, items, is_standalone_page
   */
  create: async (values) => {
    const path = API_PATH

    //convert to boolean
    values.is_standalone_page = values.is_standalone_page === 'yes'

    const response = await axios.post(path, values)
    return response
  },

  /**
   * Add Product Collection Items
   * Invoke `POST api/v2/admins/products/collections/:id/items
   * @param {array} items - array of product_ids
   * @param {string} id - id of product collection
   */
  addItems: async ({ items, id }) => {
    const path = `${API_PATH}/${id}/items`


    const response = await axios.post(path, { items })
    return response
  },

  /**
   * Delete Product Collection Items
   * Invoke `DELETE api/v2/admins/products/collections/:id/items/:item_id
   * @param {string} item_id - id of product collection
   * @param {string} id - id of product collection
   */
  deleteItem: async ({ itemId, id }) => {
    const path = `${API_PATH}/${id}/items/${itemId}`


    const response = await axios.delete(path, { })
    return response
  }
}

export default ProductCollectionsApiV2
